export const LinkExternalIcon = () => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2.5 18.5C1.95 18.5 1.47917 18.3042 1.0875 17.9125C0.695833 17.5208 0.5 17.05 0.5 16.5V2.5C0.5 1.95 0.695833 1.47917 1.0875 1.0875C1.47917 0.695833 1.95 0.5 2.5 0.5H9.5V2.5H2.5V16.5H16.5V9.5H18.5V16.5C18.5 17.05 18.3042 17.5208 17.9125 17.9125C17.5208 18.3042 17.05 18.5 16.5 18.5H2.5ZM7.2 13.2L5.8 11.8L15.1 2.5H11.5V0.5H18.5V7.5H16.5V3.9L7.2 13.2Z" />
    </svg>
  );
};
